import { render, staticRenderFns } from "./Expostion.vue?vue&type=template&id=9130e0be&"
import script from "./Expostion.vue?vue&type=script&lang=js&"
export * from "./Expostion.vue?vue&type=script&lang=js&"
import style0 from "./Expostion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports